/* eslint-disable global-require */

'use-strict';

import { RouteProvider } from '../../app.upgraded.routes';

/* @ngInject */
export default function routing(
  $routeProvider: RouteProvider,
): void {
  $routeProvider
    .when('/vehicles/bodycodes', {
      title: 'Bodycodes',
      templateUrl: require('./bodycodes.template.html'),
    });
}
